import React from 'react';

const Actions = () => {
    return (
        <div className="d-flex">
            <div className="action align-self-center">
                <a href="assets/docs/resume.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-primary">DOWNLOAD CV</a>
            </div>
        </div>
    );
};

export default Actions;
